export function WGUAccessControl() {
  var coursenum = window.location.pathname.split('/')[3]
  if (typeof coursenum === 'undefined') {
    coursenum = '-'
  }
  const ONE_MIN_MILLISECONDS = 60000
  const TWO_MINS_SECONDS = 60 * 2
  const WGU_SESSION_TIME = 43
  var idleTime = 0
  var idle = true
  var timerRunning = false
  var sessionEnded = false

  $(function () {
    setInterval(function () {
      timerIncrement()
    }, ONE_MIN_MILLISECONDS)

    $(this).on('mousemove', function () {
      idle = false
    })
    $(this).on('keypress', function () {
      idle = false
    })
  })

  function timerIncrement() {
    if (idle) {
      idleTime = idleTime + 1
    } else {
      resetTimer()
    }

    if (idleTime > WGU_SESSION_TIME && !timerRunning && !sessionEnded) {
      var timerId = startTimer()
      $.meDialog.confirm(
        '<div id="SessionModal_Title">Continue Session?</div>',
        '<div id="SessionModal_Body">Do you want to continue your session? </br> </br> Your session will time out in <span id="SessionTimer">2:00</span></div>',
        {
          'Continue Session': function () {
            resetTimer(timerId)
          },
        }
      )
    }
    idle = true
  }

  function resetTimer(timerId = null) {
    if (timerId) {
      window.clearInterval(timerId)
      timerRunning = false
    }

    idleTime = 0
    $.ajax({
      url: '/custom/wgu_connector.reset_session_expiration',
      dataType: 'html',
    })
  }

  function startTimer() {
    timerRunning = true
    var timer = TWO_MINS_SECONDS
    var minutes
    var seconds

    var timerId = window.setInterval(function () {
      minutes = parseInt(timer / 60, 10)
      seconds = parseInt(timer % 60, 10)
      seconds = seconds < 10 ? '0' + seconds : seconds

      var display = minutes + ':' + seconds
      $('#SessionTimer').text(display)
      timer = timer - 1

      if (timer < 0 && !sessionEnded) {
        $.ajax({
          url: '/account/logout/',
        }).always(function () {
          window.clearInterval(timerId)
          $('#SessionModal_Title').text('Session Ended')
          $('#SessionModal_Body').text(
            "Your session has ended. Please launch a new session from your school's student portal."
          )
          $('.modal-body button').text('Close')
          sessionEnded = true
        })
      }
    }, 1000)

    return timerId
  }
}
